import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainHeaderComponent } from './main-header/main-header.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { UserMenuComponent } from './main-header/user-menu/user-menu.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NotificationComponent } from './main-header/notification/notification.component';
// import { ChoiceClientViewComponent } from './main-header/choice-client-view/choice-client-view.component';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    MainHeaderComponent,
    MainNavComponent,
    UserMenuComponent,
    NotificationComponent,
    // ChoiceClientViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FontAwesomeModule,
    MatInputModule
  ],
  exports: [
    MainHeaderComponent,
    MainNavComponent
  ]
})
export class MainModule { }
